module.exports = __webpack_public_path__ + "static/media/fruit-peach-1.70297a7a.png";